import React from 'react';
import '@aurodesignsystem/auro-input';
import * as Constants from "../../../constants/Constants";

interface SearchFilterProps {
  searchFilterValue: string;
  onSearchFilterValueChange: (value: string) => void;
}

const SearchFilter: React.FC<SearchFilterProps> = ({ searchFilterValue , onSearchFilterValueChange }) => {

  const stripHtmlTags = (input: string) => {
    const doc = new DOMParser().parseFromString(input, 'text/html');
    return doc.body.textContent || "";
  };

  const handleSearchFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    // Strip HTML from the input value
   let strippedValue = stripHtmlTags(inputValue);
   // Remove any characters that don't match the pattern
       const sanitizedvalue = strippedValue.replace(Constants.PROBLEMTEXT_LOCATION_REGEX_REPLACE, '');
       if (Constants.PROBLEMTEXT_LOCATION_REGEX_PATTERN.test(sanitizedvalue)) {
            event.target.value = sanitizedvalue;
            onSearchFilterValueChange(sanitizedvalue);
        }
  };

  return (
    <div className="search-filter">
    <input
      type="text"
      className="input-with-svg"
      placeholder="Search problem statement"
      value={searchFilterValue}
      onChange={handleSearchFilterChange}
    />
    </div>
  );
};

export default SearchFilter;